import Vue from "vue";
import Router from "vue-router";
import { getOauth2 } from "@/api/user";
import { getUserInfoApi } from '@/api/login';
import dd from "gdt-jsapi";
Vue.use(Router);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/home/index"),
    meta: {
      title: "人宠共患病防控一件事"
    }
  },
  {
    path: "/vaccineCabinet",
    name: "vaccineCabinet",
    component: () => import("@/views/vaccineCabinet/index.vue"),
    meta: {
      title: "疫苗柜绑定防疫点"
    }
  },
  {
    path: "/vaccineCabinetAdd",
    name: "vaccineCabinetAdd",
    component: () => import("@/views/vaccineCabinet/add.vue"),
    meta: {
      title: "新增疫苗柜"
    }
  },
  {
    path: "/stationQuery",
    name: "stationQuery",
    component: () => import("@/views/stationQuery/index.vue"),
    meta: {
      title: "疫苗柜查询"
    }
  },
  {
    path: "/downgrade",
    name: "downgrade",
    component: () => import("@/views/downgrade-page/index.vue"),
    meta: {
      title: "加载失败"
    }
  },
  {
    path: "/:pathMatch(.*)*",
    name: "404",
    component: () => import("@/views/404/index"),
    meta: {
      title: "加载失败"
    }
  },
];

const router = new Router({
  mode: "history",
  routes,
  scrollBehavior: () => ({ y: 0 }),
});
let hasOnceShow = false;
const isSwitch = process.env.NODE_ENV === 'development' ? false : true;
//设置路由守卫
router.beforeEach((to, from, next) => {
  // 设置title
  setTitle(to);
  if  (!isSwitch) {
    next();
    return
  }
  if (!hasOnceShow) {
    dd.ready(function () {
      dd.getAuthCode({}).then((result) => {
        let auth_code;
        if (result.code) {
          auth_code = result.code;
        } else {
          auth_code = result.auth_code;
        }
        getOauth2(auth_code)
          .then(async (res) => {
            if (res.code === 0) {
              let { token } = res.data;
              sessionStorage.setItem("token", token);
              sessionStorage.setItem('USERINFO', JSON.stringify(res.data));
              // sessionStorage.setItem("token", res.content.petUserToken);
              // getUserInfoApi(res.data.userId).then(res => {
              //   if (res.code === 0) {
              //     sessionStorage.setItem('USERINFO', JSON.stringify(res.data));
              //     next();
              //   } else {
              //     if (to.path !== "/404") {
              //       next("/404");
              //     } else {
              //       next();
              //     }
              //   }
              // })
              hasOnceShow = true;
              next();
            } else {
              if (to.path !== "/404") {
                next("/404");
              } else {
                next();
              }
            }
          })
          .catch((err) => {
            // console.log('接口失败');
            if (to.path !== "/404") {
              next("/404");
            } else {
              next();
            }
          });
      });
    });
  }else {
    next();
  }
});

const setTitle = (to) => {
  console.log(to)
  if (to.name === 'vaccineCabinetAdd') {
    document.title = to.query.type;
  } else {
    document.title = to.meta.title;
  }
}

export default router;
